// 评分规则说明（培哥补充0502）
// 系统全局唯一配置，展示在评估页右侧分数面板

export const scoringRules = {
  rule_id: 1,
  content: '加分项表明员工存在离职倾向，勾选"是"即累加对应分值。\n\n0-4分：低风险\n5-10分：中风险\n≥11分：高风险\n\n提示：不了解选项不影响得分，但会标记为待确认状态。',
  updated_at: '2026-05-02 10:00:00'
}

export function getStoreScoringRules() {
  const s = require('../store').default
  // 优先从 settings store 读取（updateSetting 保存时写入 settings.scoring_rules）
  const settings = s.state.settings && s.state.settings.settings
  if (settings && settings.scoring_rules && settings.scoring_rules.content) {
    return settings.scoring_rules
  }
  // 回退到 scoringRules store
  if (s.state.scoringRules && s.state.scoringRules.rules && s.state.scoringRules.rules.content) {
    return s.state.scoringRules.rules
  }
  return scoringRules
}
